import React from 'react';
import styles from './TabsPageContainer.module.scss';
import { Tabs, ScrollableContainer, LabeledDropdown } from 'components';
import { observer } from 'mobx-react-lite';
import { inject } from 'mobx-react';
import { EDITOR_SHOTS_STORE } from 'store';
import ShotLocationChanger from './ShotLocationChanger';
import { TabsPageContainerProps } from './types';

const TabsPageContainer = (props: TabsPageContainerProps) => {
  const {
    tabs,
    selectedTab,
    setSelectedTab,
    children,
    sideComponent = <div />,
    onSelect = () => null,
    filterOptions = [],
    selectedFilter = '',
    onFilterSelect = (_) => null,
    [EDITOR_SHOTS_STORE]: {
      selectedShotsForLocationChangeNumber
    }
  } = props;
  return (
    <div className={styles.container}>
      <div
        // className={styles.headerContainer}
      >
        {
          !!filterOptions.length &&
          <LabeledDropdown
            options={filterOptions}
            selectedOptions={[selectedFilter]}
            onSelect={([value]) => onFilterSelect(value)}
            placeholder='filter by location'
            size='mini'
            className={styles.filterDropdown}
            optionClassName={styles.option}
          />
        }
        {
          !!selectedShotsForLocationChangeNumber &&
          <ShotLocationChanger />
        }
        <Tabs
          tabs={tabs}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          onSelect={onSelect}
        />
      </div>
      <div className={styles.body}>
        <ScrollableContainer
          className={styles.scrollableContainer}
        >
          {children}
        </ScrollableContainer>
        <div className={styles.sideComponentContainer}>
          {sideComponent}
        </div>
      </div>
    </div>
  );
};

export default inject(EDITOR_SHOTS_STORE)(observer(TabsPageContainer));
